/** 날짜 구분선 (DESIGN_SPEC 6장). "아침 · 10월 12일 월" / "저녁". 양옆 hairline, 위아래 20 */
export function DateDivider({ label }) {
    return (
        <div role="separator" aria-label={label} className="flex items-center gap-3 py-5">
            <span aria-hidden="true" className="h-px flex-1 bg-hairline" />
            <span aria-hidden="true" className="text-section text-label-muted">
                {label}
            </span>
            <span aria-hidden="true" className="h-px flex-1 bg-hairline" />
        </div>
    );
}
